<template>
  <div class="lead-qualification-flow">
    <riseup-header/>
    <component
      :is="getComponent()"
      v-bind="getComponentProps()"/>
  </div>
</template>

<script>
import BaseUI from 'base-ui';
import { mapState, mapActions, mapGetters } from 'vuex';
import RadioButtonSurvey from '../../../../../base-components/survey/RadioButtonSurvey.vue';
import ValueProp from './value-props/ValueProp.vue';
import ValuePropCashflowGoal from './value-props/ValuePropCashflowGoal.vue';
import valueProps from './consts/value-props';
import questions from './consts/questions';
import RiseupHeader from '../../../../../base-components/app-header/RiseupHeader.vue';

export default {
  name: 'LeadQualificationSurvey',
  components: {
    RiseupHeader,
    RiseupButton: BaseUI.RiseupButton,
    RadioButtonSurvey,
    ValueProp,
    ValuePropCashflowGoal,
  },
  props: {
    componentName: {
      type: String,
      required: true,
    },
    componentType: {
      type: String,
      required: true,
    },
  },
  created() {
    this.gotoPage({ componentName: this.componentName, componentType: this.componentType });
  },
  computed: {
    ...mapState('leadQualification', ['componentTypes']),
    ...mapGetters('leadQualification', ['currentQuestion', 'questionIndex']),
  },
  methods: {
    ...mapActions('leadQualification', ['gotoPage', 'nextPage']),
    getComponentProps() {
      if (this.componentType === this.componentTypes.QUESTION) {
        return {
          ...this.currentQuestion,
          index: this.questionIndex,
          totalQuestions: questions.QUESTIONS.length,
          next: this.nextPage,
          segmentPrefix: 'LQQuestion',
        };
      }
      return {
        componentName: this.componentName,
        next: this.nextPage,
      };
    },
    getComponent() {
      if (this.componentType === this.componentTypes.QUESTION) {
        return 'RadioButtonSurvey';
      }
      if (this.componentType === this.componentTypes.VALUE_PROP && this.componentName === valueProps.VALUE_PROP_NAMES.CASHFLOW_GOAL) {
        return 'ValuePropCashflowGoal';
      }

      return 'ValueProp';
    },
  },
  watch: {
    componentName(componentName) {
      this.gotoPage({ componentName, componentType: this.componentType });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../../../node_modules/base-ui/src/scss/riseup-colors';
@import '../../../../../scss/mixins';

.lead-qualification-flow {
  @include white-page-frame;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/non-authenticated/wine-and-dine/lead-qualification/LeadQualificationFlow.vue